import TriggerType from './TriggerType';

export const WorkflowTemplateIds = {
  CB_RESPONSE_ISOLATE: '83485974-27fa-47b6-9032-08bc460fcc22',
  CISCO_ISE_QUARANTINE_HOST: '1b9783f2-7d92-4519-a375-38b9eac0ca3b',
  IBM_BIGFIX_PATCH: 'd5a51fc9-5f15-4b16-b484-bfa45d11756a',
  MICROSOFT_SCCM_PATCH: '3d4a21a3-9633-459f-8187-6b933542264b',
  PALO_ALTO_PAN_OS: '9f4949c7-4580-4062-8fe7-65e2d8bfa600',
};

export default Object.freeze({
  [WorkflowTemplateIds.CB_RESPONSE_ISOLATE]: 'CB_RESPONSE_ISOLATE',
  [WorkflowTemplateIds.CISCO_ISE_QUARANTINE_HOST]: 'CISCO_ISE_QUARANTINE_HOST',
  [WorkflowTemplateIds.MICROSOFT_SCCM_PATCH]: 'MICROSOFT_SCCM_PATCH',
  [WorkflowTemplateIds.IBM_BIGFIX_PATCH]: 'IBM_BIGFIX_PATCH',
  [WorkflowTemplateIds.PALO_ALTO_PAN_OS]: 'PALO_ALTO_PAN_OS',
});

export const WORKFLOW_TEMPLATE_IDS_BY_TRIGGER_TYPE = {
  [TriggerType.ASSET]: [
    WorkflowTemplateIds.CB_RESPONSE_ISOLATE,
    WorkflowTemplateIds.CISCO_ISE_QUARANTINE_HOST,
    WorkflowTemplateIds.PALO_ALTO_PAN_OS,
  ],
  [TriggerType.VULNERABILITY]: [
    WorkflowTemplateIds.CB_RESPONSE_ISOLATE,
    WorkflowTemplateIds.CISCO_ISE_QUARANTINE_HOST,
    WorkflowTemplateIds.IBM_BIGFIX_PATCH,
    WorkflowTemplateIds.MICROSOFT_SCCM_PATCH,
    WorkflowTemplateIds.PALO_ALTO_PAN_OS,
  ],
};
